import axios from 'axios';
import getBaseUrl from '../../../shared/utils/Host';

const BaseUrl = getBaseUrl();
const API_URL_WEB = `${BaseUrl}type-product`;

export const getTypeCategories = () => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}

export const getTypeCategoriesById = (id) => {
    const token = localStorage.getItem('token');

    return axios.get(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}

export const createTypeCategories = (typeCategories) => {
    const token = localStorage.getItem('token');

    return axios.post(`${API_URL_WEB}`,
        typeCategories, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}

export const updateTypeCategories = (id, typeCategories) => {
    const token = localStorage.getItem('token');

    return axios.patch(API_URL_WEB + `/${id}`,
        typeCategories, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}

export const deleteTypeCategories = (id) => {
    const token = localStorage.getItem('token');

    return axios.delete(`${API_URL_WEB}/${id}`, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}

export const updateActive = (id, typeProduct) => {
    const token = localStorage.getItem('token');

    return axios.patch(API_URL_WEB + `/active-type/${id}`,
        typeProduct, {
        headers: {
            Authorization: `Bearer ${token}`,
        },
    });
}